import { render, staticRenderFns } from "./msRadio.vue?vue&type=template&id=2d07b851&scoped=true"
import script from "./msRadio.vue?vue&type=script&lang=js"
export * from "./msRadio.vue?vue&type=script&lang=js"
import style0 from "./msRadio.vue?vue&type=style&index=0&id=2d07b851&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d07b851",
  null
  
)

export default component.exports